
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';

const StudentViewLogin = () => {
  const [formData, setFormData] = useState({
    usn: '',
    password: ''
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      console.log('Login attempt with:', formData.usn.toUpperCase()); // Debug log

      const response = await api.post('/auth/login', {
        usn: formData.usn.toUpperCase(),
        password: formData.password,
        role: 'student'
      });

      console.log('Login response:', response.data);

      // Save to localStorage
      localStorage.setItem('token', response.data.token);
      localStorage.setItem('usn', response.data.user.usn);
      localStorage.setItem('userId', response.data.user._id);
      localStorage.setItem('user', JSON.stringify(response.data.user));
      localStorage.setItem('userRole', 'student');

      console.log('Saved to localStorage - USN:', localStorage.getItem('usn'));

      alert('✅ Login successful!');
      navigate('/student-dashboard');
    } catch (error) {
      console.error('Login error:', error);
      const errorMsg = error.response?.data?.message || 'Login failed. Please try again.';
      setError(errorMsg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.formCard}>
        <div style={styles.header}>
          <h2 style={styles.title}>👁️ Student View Login</h2>
          <p style={styles.subtitle}>View your placement records</p>
        </div>

        {error && <div style={styles.error}>{error}</div>}

        <form onSubmit={handleSubmit} style={styles.form}>
          <div style={styles.inputGroup}>
            <label style={styles.label}>USN *</label>
            <input
              type="text"
              name="usn"
              value={formData.usn}
              onChange={handleChange}
              style={styles.input}
              placeholder="Enter your USN (e.g., 4SF22CS061)"
              required
            />
          </div>

          <div style={styles.inputGroup}>
            <label style={styles.label}>Password *</label>
            <input
              type="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              style={styles.input}
              placeholder="Enter your password"
              required
            />
          </div>

          <button type="submit" style={styles.submitButton} disabled={loading}>
            {loading ? 'Logging in...' : 'Login'}
          </button>
        </form>

        <div style={styles.footer}>
          <p style={styles.footerText}>
            Don't have an account? <a href="/student-registration" style={styles.link}>Register here</a>
          </p>
          <p style={styles.footerText}>
            <a href="/" style={styles.link}>← Back to Home</a>
          </p>
        </div>
      </div>
    </div>
  );
};

const styles = {
  container: {
    minHeight: '100vh',
    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '2rem',
  },
  formCard: {
    background: 'white',
    borderRadius: '20px',
    padding: '3rem',
    maxWidth: '500px',
    width: '100%',
    boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
  },
  header: {
    textAlign: 'center',
    marginBottom: '2rem',
  },
  title: {
    fontSize: '2rem',
    color: '#333',
    margin: '0 0 0.5rem 0',
  },
  subtitle: {
    color: '#666',
    margin: 0,
  },
  error: {
    background: '#fee',
    color: '#c33',
    padding: '1rem',
    borderRadius: '10px',
    marginBottom: '1.5rem',
    textAlign: 'center',
    fontWeight: '600',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1.5rem',
  },
  inputGroup: {
    display: 'flex',
    flexDirection: 'column',
  },
  label: {
    fontSize: '0.9rem',
    fontWeight: '600',
    color: '#555',
    marginBottom: '0.5rem',
  },
  input: {
    padding: '0.9rem 1rem',
    border: '2px solid #ddd',
    borderRadius: '10px',
    fontSize: '1rem',
    outline: 'none',
    transition: 'border 0.3s ease',
  },
  submitButton: {
    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    color: 'white',
    border: 'none',
    padding: '1rem',
    borderRadius: '10px',
    fontSize: '1.1rem',
    fontWeight: '600',
    cursor: 'pointer',
    marginTop: '1rem',
    transition: 'transform 0.2s ease',
  },
  footer: {
    marginTop: '2rem',
    textAlign: 'center',
  },
  footerText: {
    color: '#666',
    margin: '0.5rem 0',
  },
  link: {
    color: '#667eea',
    textDecoration: 'none',
    fontWeight: '600',
  },
};

export default StudentViewLogin;
